'use client'

import { env } from '@shared/config/env'
import { NativeBridgeStore } from '@shared/models'
import Script from 'next/script'

type Props = Pick<NativeBridgeStore, 'from' | 'runtimeVersion'>

export const ScriptProvider = ({ from, runtimeVersion }: Props) => {
  // 디바이스 정보만 전송 (page_view는 layout.tsx의 gtag config에서 관리)
  const DEVICE_INFO_SCRIPT = /* javascript */ `
    (function () {
      window.dataLayer = window.dataLayer || [];
      
      // Send custom device info
      window.dataLayer.push({
        event: 'device_info',
        userOs: window.DEVICE_OS || 'web',
        userOsVersion: window.DEVICE_OS_VERSION || 'web',
        userAppVersion: window.NATIVE_APP_VERSION || '${runtimeVersion}',
        userBuildVersion: window.BUILD_VERSION || 'web',
        userDeviceModel: window.DEVICE_MODEL || 'web',
        userDeviceType: window.DEVICE_TYPE || 'web'
      });
    })();
  `

  return (
    <>
      {from === 'APP' && (
        <Script
          id="RN_SAFE_JSON"
          strategy="beforeInteractive"
          dangerouslySetInnerHTML={{
            __html: /* javascript */ `
              (function(){
                try {
                  if (typeof window === 'undefined') return;
                  if (!window.ReactNativeWebView) return;
                  var _originalStringify = JSON.stringify;
                  JSON.stringify = function(value, replacer, space){
                    var seen = new WeakSet();
                    var wrapReplacer = function(key, val){
                      try {
                        if (val && typeof val === 'object') {
                          if (seen.has(val)) return '[Circular]';
                          seen.add(val);
                        }
                      } catch(_){}
                      return typeof replacer === 'function' ? replacer.call(this, key, val) : val;
                    };
                    return _originalStringify(value, wrapReplacer, space);
                  };
                } catch(_){}
              })();
            `,
          }}
        />
      )}
      <Script
        src="https://t1.kakaocdn.net/kakao_js_sdk/2.7.9/kakao.min.js"
        integrity="sha384-JpLApTkB8lPskhVMhT+m5Ln8aHlnS0bsIexhaak0jOhAkMYedQoVghPfSpjNi9K1"
        crossOrigin="anonymous"
        strategy="lazyOnload"
        onReady={() => {
          if (window.Kakao?.isInitialized()) {
            return
          }

          window.Kakao.init(env.NEXT_PUBLIC_KAKAO_JS_SDK_KEY)
          window.dispatchEvent(new Event('kakao:initialized'))
        }}
      />

      <Script id="DEVICE_INFO_PROVIDER" strategy="lazyOnload">
        {DEVICE_INFO_SCRIPT}
      </Script>
    </>
  )
}
